module.exports = __webpack_public_path__ + "static/media/simulation-select-time-icon.88585d2a.svg";